<template>
  <div class="select-multiple-tree">
    <el-select
      v-model="selectVal"
      placeholder="请选择"
      filterable
      :multiple="multiple"
      :filter-method="selectTreeList"
      @change="selectChange"
    >
      <el-option
        :value="treeDataValue"
        class="selectTree"
        style="height: auto"
      >
        <el-tree
          ref="tree"
          node-key="id"
          :filter-node-method="filterNode"
          :data="list"
          :props="defaultProps"
          show-checkbox
          check-strictly
          :highlight-current="true"
          :expand-on-click-node="false"
          @check-change="handleNodeCheck"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="data.children" class="iconfont" style="margin-right: 16px">
              <img :src="data.img">
            </span>
            <span v-if="!data.children&&!data.image" class="children-img" style="margin-right: 16px">
              <img :src="data.img">
            </span>
            <span v-if="data.image" style="margin-right:10px;">
              <img class="select-img" :src="data.image">
            </span>
            <span>{{ node.label}}</span>          
          </span>
        </el-tree>
      </el-option>
    </el-select>
    
  </div>
</template>

<script>
export default {
  props: {
    selectObj: {
      type: Object
    },
    departmentList: {
      type: Array
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectVal: this.selectObj.labelArr,
      treeDataValue: this.selectObj.arr,
      defaultProps: {
        children: "subList",
        label: "departmentName"
      },
      list: this.departmentList,
    }
  },

  created() {
    let list = this.departmentList
    list.map(i => {
      this.getLeafKeys(i)
    })
  },
  mounted() {
    this.$bus.on('upload', v => {
      if (v == 1) {
        this.treeDataValue = ''
        this.selectVal = ''
      } else {
        this.treeDataValue = this.selectObj.arr
        this.selectVal = this.selectObj.labelArr
      }
      if (this.$refs.tree != undefined) {
        this.$refs.tree.setCheckedNodes(this.selectObj.arr);
      }
    })
  },

  methods: {
    selectTreeList(val) {
      this.$refs.tree.filter(val);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },

    selectChange(e) {
      let arrNew = []
      let dateLength = this.treeDataValue.length
      let eleng = e.length
      for(let i =0 ; i < dateLength; i++) {
        for(let j=0; j<eleng; j++) {
          if(e[j] === this.treeDataValue[i].departmentName) {
            arrNew.push(this.treeDataValue[i])
          }
        }
      }
      this.$emit("getSelectChange",arrNew)
      this.$refs.tree.setCheckedNodes(arrNew);
    },

    /* 
      通过递归的形式，获取最后一级的id，
     */
    getLeafKeys(node) {
      /* 
        如果当前 node 节点不包含 children 属性，
        则是三级节点
       */
      if (node.zzdCode == undefined) {
        /* 除了最后一级所有节点disabled为true */
        node.disabled = true;
      }
      node.subList.forEach(item => this.getLeafKeys(item));
    },

    handleNodeCheck() {
      let res = this.$refs.tree.getCheckedNodes(true, true);
      let arr = []
      let arrLable = []
      res.map(i => {
        arr.push(i)
        arrLable.push(i.departmentName)
      })
      this.selectVal = arrLable
      this.treeDataValue = arr
      this.$emit("selectTreeNodeList",this.treeDataValue)
    },
  }
}
</script>

<style lang='scss'>
.selectTree {
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner{
      display: inline-block;
    }
    .el-checkbox.is-disabled .el-checkbox__inner{
      display: none;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
    }
  }
}
.selectTree.hover, .selectTree:hover {
  background: transparent;
}
.select-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.select-multiple-tree {
  .el-tree-node__content {
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .search {
    margin-bottom: 12px;
  }
  .el-select__tags {
    top: 4px;
    transform: translateY(0%);
  }
  .el-select__input {
    height: 32px;
  }
}
</style>